<template>
  <v-card
  >
    <v-list-item
        dark
        class="primary"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-lifebuoy
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Support Request</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
    >
      <v-card-text>
        <v-text-field
            v-model="name"
            :rules="nameRules"
            label="Name"
            required
            outlined
        ></v-text-field>

        <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
            outlined
        ></v-text-field>

        <v-textarea
            v-model="body"
            :rules="bodyRules"
            label="Issue Description"
            auto-grow
            required
            outlined
        ></v-textarea>

        <v-btn
            :disabled="!valid || loading"
            color="success"
            class="mr-4"
            @click="submit"
        >
          Send Request
        </v-btn>
        <v-progress-circular
            slot="append-outer"
            v-if="loading"
            indeterminate
            color="accent"
            class="d-inline-block"
        ></v-progress-circular>
        <v-btn
            v-if="!loading"
            color="error"
            class="mr-4"
            @click="reset"
        >
          Reset Form
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>
<script>
import {errorNotification} from "@/components/utils";

export default {
  name: 'SupportForm',
  data: () => ({
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required'
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    body: '',
    bodyRules: [
      v => !!v || 'Issue description is required'
    ],
    loading: false
  }),

  methods: {
    submit() {
      if (this.validate()) {
        this.loading = true
        this.$axios.post('/support/request/', {
          name: this.name,
          email: this.email,
          body: this.body
        })
            .then(() => {
              this.reset()
              this.$store.dispatch('snackbar/success', 'Support request sent.')
            })
            .catch((error) => {
              errorNotification(error)
            })
            .finally(() => {
              this.loading = false
            })
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.resetValidation()
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>